import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import '../../styles/views/profilePage/profilePageMobile.scss';
import {
  getUserNameLastName, PageRoutes, ProfileRoutes, useViewModel,
} from '@utils';
import { Loader } from '@components';
import { FilterMobile } from '../../components/filter/FilterMobile';
import { ProfileViewModel } from './ProfileViewModel';
import { Tabs } from '../../components/tabs';

export const ProfilePageMobile: FC = observer(() => {
  const profileViewModel = useViewModel(ProfileViewModel);

  return (
    <>
      <FilterMobile />
      {profileViewModel.isLoading ? (
        <div className="loader-wrapper">
          <Loader />
        </div>
      ) : (
        <>
          <div className="profile-info">
            <img className="avatar" src={profileViewModel.profileInfo.img} />
            <div className="text-block">
              <div className="name">{getUserNameLastName(profileViewModel.profileInfo.fullName)}</div>
              <div className="email">{profileViewModel.profileInfo.corporateEmail}</div>
            </div>
          </div>
          <div className="profile-tabs">
            <Tabs
              links={
                [
                  { title: 'Детали профиля', route: PageRoutes.PROFILE_PAGE },
                  { title: 'Мои календари', route: `${PageRoutes.PROFILE_PAGE}/${ProfileRoutes.CONNECTED_CALENDARS_TAB}` },
                  { title: 'Настройка уведомлений', route: `${PageRoutes.PROFILE_PAGE}/${ProfileRoutes.NOTIFICATIONS_TAB}` },
                ]
              }
            />
          </div>
        </>
      )}
    </>
  );
});
